$(function() {

    $('.comingsoon').click(function() {
        alert('Coming Soon');
    });

    //menu_box開合
    let _h = true;
    const menu_box = $('.menu_box');
    const hamburger = $('.hamburger_link');

    TweenMax.set(menu_box, { x: 450 })
    hamburger.click(function() {
        if (_h) {
            $(this).addClass('active');
            TweenMax.to(menu_box, .4, { x: 0, ease: Power2.easeOut });
        } else {
            $(this).removeClass('active');
            TweenMax.to(menu_box, .4, { x: 450, ease: Quart.easeOut });
        }
        _h = !_h;
    });


    //anchor
    let _this;
    let _anchor;
    let _offset_top;
    let _collapse_id;
    let $collapse_handler;
    let $collapse_content;
    const $collapse_row = $('.collapse_row');
    $('.nav_link[href^="#"],.relative_link[href^="#"]').click(function(e) {
        e.preventDefault();

        _this = $(this);
        _anchor = _this.attr('href');
        _anchor = _anchor.substring(_anchor.indexOf('#') + 1);

        if (_anchor != 'collapse_sec') {
            _offset_top = $('.' + _anchor).offset().top;
        } else {
            _collapse_id = _this.data('id');
            _offset_top = $collapse_row.eq(_collapse_id).offset().top;
            $collapse_handler = $collapse_row.eq(_collapse_id).find('.collapse_handler');
            $collapse_content = $collapse_row.eq(_collapse_id).find('.collapse_content');
            $collapse_handler.attr('o', 1);
            $collapse_handler.addClass('active');
            $collapse_content.slideDown();
        }

        TweenMax.to('html, body', 1, { scrollTop: _offset_top, ease: Quart.easeOut });
        $('.nav_link').removeClass('active');
        _this.addClass('active');
    });
});